import { Link } from 'react-router-dom';

interface PricingRow {
  feature: string;
  traditional: string;
  paradigm: string;
  highlight?: boolean;
}

const rows: PricingRow[] = [
  {
    feature: 'Unlimited Pay Cycles',
    traditional: 'Extra Fees',
    paradigm: '✓ Free',
  },
  {
    feature: 'NIB Auto-Calc',
    traditional: 'Manual Work',
    paradigm: '✓ Included',
    highlight: true,
  },
  {
    feature: 'Digital Payslips',
    traditional: 'Paper-based',
    paradigm: '✓ Unlimited',
  },
];

export function PricingSection() {
  return (
    <section id="pricing" className="bg-white py-32 px-8 text-center">
      <h2 className="font-display text-[3.5rem] font-semibold tracking-tight text-deep-ink mb-4">
        Simple, friendly pricing.
      </h2>
      <p className="text-gray-500 text-xl">
        No hidden fees. No complicated tiers.
      </p>

      {/* Pricing Table */}
      <div className="max-w-[1000px] mx-auto mt-16 bg-soft-paper rounded-[32px] p-8 border border-black/[0.08]">
        {/* Header */}
        <div className="grid grid-cols-[2fr_1fr_1fr] px-4 py-6 text-left font-bold text-gray-500 text-sm uppercase tracking-wider">
          <span>The Good Stuff</span>
          <span>Traditional Firm</span>
          <span className="text-indigo-600">Paradigm</span>
        </div>

        {/* Rows */}
        {rows.map((row) => (
          <div
            key={row.feature}
            className={`grid grid-cols-[2fr_1fr_1fr] px-4 py-6 text-left rounded-xl ${
              row.highlight
                ? 'bg-white shadow-sm my-2'
                : ''
            }`}
          >
            <span className="font-body">{row.feature}</span>
            <span className="font-body text-gray-600">
              {row.traditional}
            </span>
            <span className="font-bold text-accent-teal">{row.paradigm}</span>
          </div>
        ))}

        {/* Cost Row */}
        <div className="grid grid-cols-[2fr_1fr_1fr] px-4 pt-8 mt-4 border-t border-gray-200 text-left items-center">
          <span className="font-display text-xl font-bold">Monthly Cost</span>
          <span className="font-body text-gray-600">~$250+</span>
          <span className="text-3xl text-indigo-600 font-extrabold">$29</span>
        </div>
      </div>

      <div className="mt-12">
        <Link
          to="/register"
          className="inline-block px-10 py-5 bg-indigo-600 text-white rounded-2xl font-bold hover:scale-[1.02] transition-transform duration-200"
        >
          Get Started for Free
        </Link>
      </div>
    </section>
  );
}
